import React from "react";
import {
  HiOutlineCheckCircle,
  HiOutlineShieldExclamation,
  HiOutlineUser,
  HiOutlineXCircle,
} from "react-icons/hi";

const toTitleCase = (value) =>
  String(value)
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");

export const formatUserRoleLabel = (row, userRoleTitleMap = {}) => {
  const raw = row?.role_name || userRoleTitleMap[row?.user_type];
  return raw ? toTitleCase(raw) : null;
};

const USAGE_STATUS = {
  success: {
    label: "Success",
    badge: "bg-emerald-50 text-emerald-800 ring-emerald-200/80",
    icon: HiOutlineCheckCircle,
    iconClass: "text-emerald-600",
  },
  failed: {
    label: "Failed",
    badge: "bg-red-50 text-red-800 ring-red-200/80",
    icon: HiOutlineXCircle,
    iconClass: "text-red-600",
  },
  blocked: {
    label: "Blocked",
    badge: "bg-amber-50 text-amber-900 ring-amber-200/80",
    icon: HiOutlineShieldExclamation,
    iconClass: "text-amber-600",
  },
};

export const UsageRoleBadge = ({ label }) => {
  if (!label) return null;

  return (
    <span
      className="inline-flex shrink-0 items-center gap-1.5 rounded-lg border border-[#D6E0F5]/90 bg-gradient-to-b from-white to-[#F6F8FD] py-0.5 pl-0.5 pr-2.5 text-[11px] font-semibold leading-none text-[#293F6A] shadow-[0_1px_2px_rgba(41,63,106,0.07),0_0_0_1px_rgba(255,255,255,0.8)_inset]"
      title={`Role: ${label}`}
    >
      <span
        className="flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-[5px] bg-gradient-to-br from-[#5B7EC4] to-[#3D5A96] text-white shadow-[0_1px_2px_rgba(61,90,150,0.35)]"
        aria-hidden
      >
        <HiOutlineUser className="h-3 w-3" strokeWidth={2.25} />
      </span>
      <span className="max-w-[112px] truncate tracking-tight">{label}</span>
    </span>
  );
};

export const UsageStatusBadge = ({ status }) => {
  if (!status) {
    return <span className="text-sm text-gray-400">—</span>;
  }

  const config = USAGE_STATUS[status] || {
    label: toTitleCase(status),
    badge: "bg-gray-50 text-gray-700 ring-gray-200/80",
    icon: null,
    iconClass: "text-gray-500",
  };
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-md px-2 py-1 text-[11px] font-semibold leading-none ring-1 ring-inset ${config.badge}`}
    >
      {Icon ? (
        <Icon className={`h-3.5 w-3.5 shrink-0 ${config.iconClass}`} aria-hidden />
      ) : (
        <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-gray-400" />
      )}
      {config.label}
    </span>
  );
};
